import React, { Key } from 'react';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Tab = <T extends Key>({
  items,
  onSelected,
  selectedValue,
}: {
  items: { label: string; value: T }[];
  onSelected: (value: T) => void;
  selectedValue?: T;
}) => (
  <StyledTabButtonContainer>
    {items.map(it => (
      <StyledTabButton key={it.value} isActive={selectedValue === it.value} onClick={() => onSelected(it.value)}>
        {it.label}
      </StyledTabButton>
    ))}
  </StyledTabButtonContainer>
);

const StyledTabButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 34px;
  padding: 2px;
  gap: 1px;
  border-radius: 8px;
  background-color: ${Color.Gray200};
`;

const StyledTabButton = styled.div(
  ({ isActive = false }: { isActive?: boolean }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
    border-radius: 6px;
    background-color: ${isActive ? Color.White : Color.Gray200};

    ${Typography.XXXSmall}
    font-weight: ${isActive ? FontWeight.Bold : FontWeight.Regular};
    color: ${isActive ? Color.Black : Color.Gray600};
  `,
);
